// import React, { useState, useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from 'framer-motion';
// import toast from "react-hot-toast";
// import {
//   HomeIcon,
//   InboxIcon,
//   HeartIcon as HeartOutline,
//   CogIcon,
//   ArrowLeftOnRectangleIcon,
//   XMarkIcon,
//   UserCircleIcon,
//   Bars3Icon,
//   GlobeAltIcon , UserGroupIcon
// } from "@heroicons/react/24/outline";
// import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";

// // Sidebar Component
// const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, language, translations }) => {
//   const navigate = useNavigate();

//   return (
//     <aside
//       className={`fixed lg:sticky top-0 left-0 h-screen w-64 bg-gradient-to-b from-[#FF8350] to-[#FF8350] text-white transform transition-transform duration-300 ease-in-out ${
//         isSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
//       } z-40 shadow-2xl`}
//     >
//       <div className="h-full flex flex-col">
//         <div className="p-6 border-b border-orange-100 flex justify-between items-center">
//           <h1 className="text-2xl font-bold text-white">
//             {translations[language].dashboard}
//           </h1>
//           {/* Close button - only visible on mobile */}
//           <button
//             onClick={() => setIsSidebarOpen(false)}
//             className="lg:hidden text-white hover:text-gray-200 transition-colors"
//           >
//             <XMarkIcon className="h-6 w-6" />
//           </button>
//         </div>

//         <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
//           {/* Home Button */}
//           <button
//             onClick={() => navigate("/dashboard")}
//             className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FF6D31] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
//             onMouseEnter={() =>
//               toast((t) => (
//                 <div className="flex items-center space-x-2">
//                   <HomeIcon className="h-5 w-5 text-yellow-500" />
//                   <span className="text-yellow-800">
//                     {language === "tamil"
//                       ? "திருமணம் என்பது இரண்டு இதயங்கள் தானாக இணையும் இடம்! 💖"
//                       : "Matrimony is where two hearts connect automatically! 💖"}
//                   </span>
//                 </div>
//               ))
//             }
//             onMouseLeave={() => toast.dismiss()}
//           >
//             <HomeIcon className="h-5 w-5 text-white" />
//             <span>{translations[language].home}</span>
//             <div className="absolute inset-0 bg-gradient-to-r from-yellow-200 to-yellow-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
//           </button>

//           {/* Favorites Button */}
//           <button
//                 onClick={() => navigate("/favourite")}
//                 className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FF6D31] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
//                 onMouseEnter={() =>
//                   toast((t) => (
//                     <div className="flex items-center space-x-2">
//                       <UserGroupIcon className="h-5 w-5 text-blue-500" /> {/* Matching profiles icon */}
//                       <span className="text-blue-800">
//                         {language === "tamil"
//                           ? "உங்களுக்கே பொருந்தும் ஜோடி: உங்களுக்கே பொருந்தும் ஜோடி! 💑"
//                           : "Matching Profiles: Your perfect match awaits! 💑"}
//                       </span>
//                     </div>
//                   ), {
//                     style: {
//                       background: "#DBEAFE",
//                       border: "1px solid #3B82F6",
//                     },
//                     iconTheme: {
//                       primary: "#3B82F6",
//                       secondary: "#FFFFFF",
//                     },
//                   })
//                 }
//                 onMouseLeave={() => toast.dismiss()}
//               >
//                 <UserGroupIcon className="h-5 w-5 text-white" />
//                 <span>{translations[language].favorites || "Matching Profiles"}</span>
//                 {/* Glitter Effect */}
//                 <div className="absolute inset-0 bg-gradient-to-r from-blue-200 to-blue-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
//               </button>

//           {/* My Profile Button */}
//           <button
//             onClick={() => navigate("/my")}
//             className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FF6D31] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
//           >
//             <UserCircleIcon className="h-5 w-5 text-white" />
//             <span>{translations[language].myprofile}</span>
//             <div className="absolute inset-0 bg-gradient-to-r from-green-200 to-green-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
//           </button>

//           {/* Inbox Button */}
//           <button
//             onClick={() => navigate("/inbox")}
//             className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FF6D31] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
//           >
//             <InboxIcon className="h-5 w-5 text-white" />
//             <span>{translations[language].inbox}</span>
//             <div className="absolute inset-0 bg-gradient-to-r from-blue-200 to-blue-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
//           </button>

//           {/* Settings Button */}
//           <button
//             onClick={() => navigate("/setting")}
//             className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FF6D31] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
//           >
//             <CogIcon className="h-5 w-5 text-white" />
//             <span>{translations[language].settings}</span>
//             <div className="absolute inset-0 bg-gradient-to-r from-purple-200 to-purple-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
//           </button>
//         </nav>

//         {/* Logout Button */}
//         <div className="p-4 border-t border-orange-100">
//           <button
//             onClick={() => {
//               localStorage.removeItem("authToken");
//               navigate("/login");
//             }}
//             className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FF6D31] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
//           >
//             <ArrowLeftOnRectangleIcon className="h-5 w-5 text-white" />
//             <span>{translations[language].logout}</span>
//             <div className="absolute inset-0 bg-gradient-to-r from-pink-200 to-pink-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
//           </button>
//         </div>
//       </div>
//     </aside>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast";
import {
  HomeIcon,
  InboxIcon,
  HeartIcon as HeartOutline,
  CogIcon,
  ArrowLeftOnRectangleIcon,
  XMarkIcon,
  UserCircleIcon,
  Bars3Icon,
  GlobeAltIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolid } from "@heroicons/react/24/solid";
import logoes from "../assets/Logo.png";
import AsideHomeIconWhite from "../assets/Icons/home-icon-white.svg";
import AsideHomeIconDark from "../assets/Icons/home-icon-dark.svg";
import AsideProfileIconWhite from "../assets/Icons/profile-icon-white.svg";
import AsideProfileIconDark from "../assets/Icons/profile-icon-dark.svg";
import AsideMatchingProfileIconWhite from "../assets/Icons/matching-profile-icon-white.svg";
import AsideMatchingProfileIconDark from "../assets/Icons/matching-profile-icon-dark.svg";
import AsidePointsIconWhite from "../assets/Icons/points-icon-aside-white.svg";
import AsidePointsIconDark from "../assets/Icons/points-icon-aside-dark.svg";
import AsideSettingsIconWhite from "../assets/Icons/settings-icon-white.svg";
import AsideSettingsIconDark from "../assets/Icons/settings-icon-dark.svg";
import AsideLogoutIconWhite from "../assets/Icons/logout-icon-white.svg";
import AsideLogoutIconDark from "../assets/Icons/logout-icon-dark.svg";

import AsideFavouriteIconOutlineDark from "../assets/Icons/aside-favourite-icon-dark.svg";
import AsideFavouriteIconOutlineWhite from "../assets/Icons/aside-favourite-icon-white.svg";

import FavouritesIcon from "../assets/Icons/favourite-icon-outline.png";

// Sidebar Component
const Sidebar = ({
  isSidebarOpen,
  setIsSidebarOpen,
  language,
  translations,
}) => {
  const navigate = useNavigate();

  return (
    <aside
      className={`fixed lg:sticky top-0 left-0 h-screen w-64 bg-[#FF8350]  text-white transform transition-transform duration-300 ease-in-out ${
        isSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
      } z-40`}
    >
      <div className="h-full flex flex-col">
        <div className="p-6 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-white ml-4 mt-1">
            {translations[language].dashboard}
          </h1>
          {/* Close button - only visible on mobile */}
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="lg:hidden text-white hover:text-gray-200 transition-colors"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-4 flex items-center justify-center">
          <img
            src={logoes}
            alt="Dashboard Logo"
            className="h-24 w-22 sm:h-22 sm:w-22 animate-pulse transition-transform duration-500 hover:scale-110"
          />
        </div>

        <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
          {/* Home Button */}
          <button
            onClick={() => navigate("/dashboard")}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FFF] hover:text-[#676666] transition-all duration-300 hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
            onMouseEnter={() =>
              toast((t) => (
                <div className="flex items-center space-x-2">
                  <HomeIcon className="h-5 w-5 text-yellow-500" />
                  <span className="text-yellow-800">
                    {language === "tamil"
                      ? "திருமணம் என்பது இரண்டு இதயங்கள் தானாக இணையும் இடம்! 💖"
                      : "Matrimony is where two hearts connect automatically! 💖"}
                  </span>
                </div>
              ))
            }
            onMouseLeave={() => toast.dismiss()}
          >
            <img
              src={AsideHomeIconWhite}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 group-hover:hidden"
            />
            <img
              src={AsideHomeIconDark}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 hidden group-hover:block"
            />
            <span>{translations[language].home}</span>
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-200 to-yellow-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>

          {/* Matching Profiles Button */}
          <button
            onClick={() => navigate("/matchingProfiles")}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FFF] hover:text-[#676666] transition-all duration-300 hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
            onMouseEnter={() =>
              toast(
                (t) => (
                  <div className="flex items-center space-x-2">
                    <UserGroupIcon className="h-5 w-5 text-blue-500" />{" "}
                    {/* Matching profiles icon */}
                    <span className="text-blue-800">
                      {language === "tamil"
                        ? "உங்களுக்கே பொருந்தும் ஜோடி: உங்களுக்கே பொருந்தும் ஜோடி! 💑"
                        : "Matching Profiles: Your perfect match awaits! 💑"}
                    </span>
                  </div>
                ),
                {
                  style: {
                    background: "#DBEAFE",
                    border: "1px solid #3B82F6",
                  },
                  iconTheme: {
                    primary: "#3B82F6",
                    secondary: "#FFFFFF",
                  },
                },
              )
            }
            onMouseLeave={() => toast.dismiss()}
          >
            <img
              src={AsideMatchingProfileIconWhite}
              alt="aside-matching-profile-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 group-hover:hidden"
            />
            <img
              src={AsideMatchingProfileIconDark}
              alt="aside-matching-profile-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 hidden group-hover:block"
            />
            <span>
              {translations[language].matchingProfiles || "Matching Profiles"}
            </span>
            {/* Glitter Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-200 to-blue-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>

          {/* My Profile Button */}
          <button
            onClick={() => navigate("/my")}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FFF] hover:text-[#676666] transition-all duration-300 hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
          >
            <img
              src={AsideProfileIconWhite}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-6 md:w-6 group-hover:hidden"
            />
            <img
              src={AsideProfileIconDark}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-6 md:w-6 hidden group-hover:block"
            />
            <span>{translations[language].myprofile}</span>
            <div className="absolute inset-0 bg-gradient-to-r from-green-200 to-green-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>

          {/* Points Button */}
          <button
            onClick={() => navigate("/points")}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FFF] hover:text-[#676666] transition-all duration-300 hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
          >
            <img
              src={AsidePointsIconWhite}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 group-hover:hidden"
            />
            <img
              src={AsidePointsIconDark}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 hidden group-hover:block"
            />
            <span>{translations[language].points}</span>
            <div className="absolute inset-0 bg-gradient-to-r from-blue-200 to-blue-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>

          {/* Favourites Button */}
          <button
            onClick={() => navigate("/favourite")}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FFF] hover:text-[#676666] transition-all duration-300 hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
          >
            <img
              src={AsideFavouriteIconOutlineWhite}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 group-hover:hidden"
            />
            <img
              src={AsideFavouriteIconOutlineDark}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-5 md:w-5 hidden group-hover:block"
            />
            <span>{translations[language].favourites}</span>
            <div className="absolute inset-0 bg-gradient-to-r from-purple-200 to-purple-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>
        </nav>

        {/* Logout Button */}
        <div className="p-4">
          <button
            onClick={() => {
              localStorage.removeItem("authToken");
              navigate("/login");
            }}
            className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-[#FFF] hover:text-[#676666] transition-all duration-300 hover:scale-105 hover:bg-opacity-90 relative overflow-hidden group"
          >
            <img
              src={AsideLogoutIconWhite}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-6 md:w-6 group-hover:hidden"
            />
            <img
              src={AsideLogoutIconDark}
              alt="aside-home-icon"
              className=" w-5 h-5 sm:h-5 sm:w-5 md:h-6 md:w-6 hidden group-hover:block"
            />
            <span>{translations[language].logout}</span>
            <div className="absolute inset-0 hover:bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
